import React from "react";

import { TeamContext } from "../contexts/team-context";

/**
 * @returns {object} The team context data
 */
export default function useTeam() {
  const context = React.useContext(TeamContext);

  if (!context) {
    throw new Error("useTeam must be used within a TeamProvider");
  }

  return context;
}
